import { useContext, useEffect, useRef } from "react";
import { Link, Form, useActionData, redirect, useLoaderData, useNavigate  } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import { login, getSystemMsg } from '../utils/api';

import MenuContext from '../store/MenuContext';
import HeaderClasses from '../components/AppHeader/AppHeader.module.css';
import {addRequiredStateTest} from '../utils/auth';

import RegisterClasses from '../components/Register/Register.module.css';


const Login = () => {
		
   	const actionData=useActionData();
	const systemMsg=useLoaderData();
	const cartState = useSelector(state => state.cart);
	const menuTheme = useContext(MenuContext);
	const dispatch = useDispatch();
	const navigate = useNavigate();
    const ranRef = useRef(false);
	
	useEffect(() => {
		const qty = Number(actionData?.cartQty) || 0;
		if (qty >= 1 && !ranRef.current) {
		  ranRef.current = true;
		  (async () => {
			const addedTests = await addRequiredStateTest(dispatch);
			if(addedTests !== "CANNOT ORDER") {
				navigate("../cart?review=1", { replace: true });
			}else{
				navigate("../noServiceSysMsg", { replace: true});
			}	
		  })();
		}
	  }, [actionData, dispatch, navigate]);
	  
    return (
    		<div className={RegisterClasses.testInfo}>
    		  <div className={RegisterClasses.testInfoContent} style={{ display: 'flex', flexDirection: 'column' }}>
			   {systemMsg && Object.keys(systemMsg).length > 0 && (
				  <div className={RegisterClasses.systemMsg}>
					{systemMsg}
				  </div>
				)}
				<Form method='post'>
					<div className={RegisterClasses['form-control']}>
						{actionData?.errors && <div className={HeaderClasses.error}>{actionData.errors}</div>}
						<label htmlFor="Username">Username:</label> 
						<input name="Username" type="text"/><br/>
						<label htmlFor="password">Password:</label>
						<input name="password" type="password" />
						<input type="hidden" name="cartQTY" defaultValue={cartState.totalQuantity} />
						<nav className={HeaderClasses.headerNav}>
							<div className={RegisterClasses.buttonArea}>  
				            	<button className={RegisterClasses.buttonDarkBlue}>Login</button>
							
								<Link to='../register' className={RegisterClasses.buttonArea}>
									<button className={RegisterClasses.buttonDarkBlue}>Register</button>
									<span className="sr-only">Register</span>					
 								</Link>
				            </div>
						</nav>
						<div className={HeaderClasses.buttonArea}>  
				  			<div className={HeaderClasses.navAreaWhite}>
				  				<Link className={HeaderClasses.navAreaText} to='../ForgotUsername' >Forgot Username</Link>
				  				<Link className={HeaderClasses.navAreaText} to='../ForgotPassword'>Forgot Password</Link>	
								<Link className={HeaderClasses.navAreaText} to='../ForgotUsername?resend=1'>Resend Activation Code</Link>									
							</div>
						</div>
					</div>
				</Form>
			</div>
		</div>
	);
};

export default Login;

export async function loginAction({ request, params }) {
  const data = await request.formData();

  const messages={};
  const loginData = {
	username: data.get('Username'),
	password: data.get('password')
  };
  const resData = await login(loginData);
  
  if(resData.token) {
	const token = resData.token;
	const labtestid = resData.labtestid;
	messages.message="Welcome!"
	sessionStorage.setItem('token', token);	
	sessionStorage.setItem('Labtestid',labtestid);
	sessionStorage.setItem('Adult','Yes');
	const expiration = new Date();
    expiration.setHours(expiration.getHours() + 1);
    sessionStorage.setItem('expiration', expiration.toISOString());
	if(data.get("cartQTY") >=1) {
		messages.cartQty=data.get("cartQTY");
		return(messages);
		//await addRequiredStateTest(dispatch);
		//return redirect('../cart?review=1');
	}
	if(data.get("cartQTY") <1) return redirect('../');
  }else{
	  messages.errors="Could not validate login.";
	  return messages;
  };

}
export async function loader() {
    const response = await getSystemMsg("Login");
	const resData = await response;
		return resData;
}
